import config from "@/config";
import Axios from "@/utils/Axios";

export function getNoliboxSmallModels(type: 1 | 2) {
  return Axios.post(
    "/model/list",
    {
      type,
    },
    {},
    config.creatorUrl,
  );
}
